import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { errorResponse, okResponseList } from '../../utils/response';
import { Token, UserCode, EmployeeCode, Company } from '../../utils/users';
import { encryption } from '../../utils/encryption';

export function getPayrolls() {
    let url = 'payrollRegister/getPayrolls?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeCode: encryption(EmployeeCode()),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponseList(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}